import { useMemo } from 'react';
import { useAuth } from '../../../auth/auth.hook';
import { useConfig } from '../../../config/config.hook';
import { useMatriculaAtiva } from '../../../matricula-ativa/use-matricula-ativa.hook';
import { useUsuario } from '../../usuario.hook';
import { PerfilAluno, PerfilEducador } from '../../usuario.types';
import { DadosUsuario } from './use-dados-usuario.types';

/**
 * Hook para obter os dados do usuário autenticado.
 * @param {string} urlTipo - Tipo de URL a ser utilizada para obter a configuração, API ou API_DEDICADA.
 * @returns {DadosUsuario} Dados do usuário autenticado.
 */

export const useDadosUsuario = (urlTipo: string = 'API_DEDICADA'): DadosUsuario => {
  const { token } = useAuth();
  const { getValueOrThrow } = useConfig();
  const { get } = useUsuario();

  const perfil = get<PerfilAluno | PerfilEducador>();

  const matriculaAtiva = useMatriculaAtiva();

  const emailUtilizado = useMemo(() => perfil?.aura?.dados?.emailUtilizado || '', [perfil]);

  const urlBase = useMemo(() => getValueOrThrow<string>(urlTipo), [getValueOrThrow, urlTipo]);

  return { token, matriculaAtiva, emailUtilizado, urlBase };
};
